import { RadioButtonDesignTokens } from '@primeuix/themes/types/radiobutton';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/radiobutton/index.ts
const rb = componentCommon.radiobutton;

export const RadiobuttonTelekomDT: RadioButtonDesignTokens = {
  root: {
    width: t(rb.width),
    height: t(rb.height),
    background: t(rb.background),
    checkedBackground: t(rb.checked.background),
    checkedHoverBackground: t(rb.checked.hover.background),
    disabledBackground: t(rb.disabled.background),
    filledBackground: t(rb.filled.background),
    borderColor: t(rb.border.color),
    hoverBorderColor: t(rb.hover.border.color),
    focusBorderColor: t(rb.focus.border.color),
    checkedBorderColor: t(rb.checked.border.color),
    checkedHoverBorderColor: t(rb.checked.hover.border.color),
    checkedFocusBorderColor: t(rb.checked.focus.border.color),
    checkedDisabledBorderColor: t(rb.checked.disabled.border.color),
    invalidBorderColor: t(rb.invalid.border.color),
    focusRing: {
      width: t(rb.focus.ring.width),
      color: t(rb.focus.ring.color),
      offset: t(rb.focus.ring.offset),
    },
    sm: {
      width: t(rb.sm.width),
      height: t(rb.sm.height),
    },
    lg: {
      width: t(rb.lg.width),
      height: t(rb.lg.height),
    },
  },
  icon: {
    size: t(rb.icon.size),
    checkedColor: t(rb.icon.checked.color),
    checkedHoverColor: t(rb.icon.checked.hover.color),
    disabledColor: t(rb.icon.disabled.color),
    sm: {
      size: t(rb.icon.sm.size),
    },
    lg: {
      size: t(rb.icon.lg.size),
    },
  },
};
